import axiosInstance from "../../../../app/myAxiosInstance";

const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

/**
 * Method to get all vendors
 * @param {Object} data
 */
async function getVendors(data) {
  try {
    const result = await axiosInstance.get(`${baseApiUrl}admin/vendors`, { params: data });
    return result;
  } catch (err) {
    console.error('error in getVendors ', err);
  }
}

/**
 * Method to get vendor by id
 * @param {Number} id
 */
async function getVendorById(id) {
  try {
    const url = `${baseApiUrl}admin/vendors/${id}`;

    console.log("Request URL:", url);

    const result = await axiosInstance.get(url);
    console.log("Request URL:", result);
    return result;
  } catch (err) {
    console.error("Error in getVendorById:", err);
  }
}

/**
 * Method to create a vendor
 * @param {Object} data
 */
async function createVendor(data) {
  try {
    const result = await axiosInstance.post(`${baseApiUrl}admin/vendors`, data);
    return result;
  } catch (err) {
    console.error('error in createVendor ', err);
  }
}

/**
 * Method to update a vendor
 * @param {Number} id
 * @param {Object} data
 */
async function updateVendor(id, data) {
  try {
    const result = await axiosInstance.patch(`${baseApiUrl}admin/vendors/${id}`, data);
    return result;
  } catch (err) {
    console.error('error in updateVendor ', err);
  }
}

/**
 Create settlment a/c on cashfree
 */
async function createSettlementAccount(bankAccountId) {
  try {
    const result = await axiosInstance.patch(`${baseApiUrl}admin/bankAccounts/${bankAccountId}/createSettlementAccount`, "");
    return result;
  } catch (err) {
    console.error('error in createSettlementAccount ', err);
  }
}

/*
    Create vendor kyc documents
 */
async function createVendorDocuments(formData) {
  try {
    const result = await axiosInstance.post(`${baseApiUrl}admin/documents`, formData);
    return result;
  } catch (err) {
    console.error('error in createVendorDocuments ', err);
  }
}

export const VendorsServices = {
  getVendors,
  getVendorById,
  createVendor,
  updateVendor,
  createSettlementAccount,
  createVendorDocuments
};
